import { FlagIcon } from 'react-flag-kit';
import { default as Stack } from '@mui/material/Stack';
import { DropdownMenu } from 'components/dropdown-menu';
import { AppLocale, getLocaleLanguage, getTrans } from 'modules/i18n';
import { mapFlagCode } from '../constants';
import { MenuItem } from './MenuItem';

export const Switcher = () => {
  const appLocale = getLocaleLanguage();

  const icon = () => (
    <FlagIcon
      code={mapFlagCode[appLocale]}
      size={20}
      width={28}
      style={{ borderRadius: 3 }}
    />
  );

  return (
    <DropdownMenu icon={icon} ariaLabel="lng-icon-label">
      <Stack sx={{ p: 1 }}>
        <MenuItem
          label={getTrans('language.english')}
          locale={AppLocale.en_US}
        />
        <MenuItem
          label={getTrans('language.german')}
          locale={AppLocale.de_DE}
        />
      </Stack>
    </DropdownMenu>
  );
};
